<template>
  <div>
    <el-form :model="qmsForm" ref="qmsForm" label-width="100px">
          <el-row>
            <el-col>
              <el-form-item label="处理意见" prop="processingModeSuggestion">
                <el-input v-model="qmsForm.processingModeSuggestion" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="small" type="primary" @click="saveConfirm">保存</el-button>
          <el-button size="small" type="primary" @click="onCancel">取消</el-button>
        </el-row>
  </div>
</template>

<script>
import QIPApi from "@/api/QIP/index";
export default {
  props: ['idList',"dialogTit"],
  data() {
    return {
      qmsForm: {
        processingModeSuggestion: ""
      },
    }
  },
  watch: {
    idList: {
      handler(newV, oldV) {
        console.log('newV', newV);
      },
      immediate: true
    }
  },
  methods: {
    saveConfirm() {
      if(this.dialogTit === 'Y') {
        this.confirmFcReq('PART_REJECT',"操作成功")
      } else if(this.dialogTit === 'N') {
        this.confirmFcReq('REJECT','操作成功')
      } else {
        this.confirmFcReq('CQSISSUED', '操作成功')
      }
    },
    confirmFcReq(type, msg) {
      QIPApi.updateBatchQipStatus({
        idList: this.idList,
        type: type,
        processingModeSuggestion:this.qmsForm.processingModeSuggestion
      }).then(res => {
        console.log('提交数据', res);
        if (res.meta.code === 200) {
          this.$message.success(msg)
          this.onCancel()
        }
      });
    },
    onCancel() {
      this.qmsForm = {
        processingModeSuggestion: ""
      }
      this.$emit('onCloseReject')
    },
  }
}
</script>

<style>
</style>
